<template>
  <el-table-column
    prop="is_valid"
    label="Érvényes"
    show-overflow-tooltip
    min-width="160"
  >
    <template slot-scope="scope">
      <el-tag v-if="!scope.row.is_valid" type="danger" size="small">Nem</el-tag>
      <el-tag v-else type="success" size="small">Igen</el-tag>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'is_valid',
  };
</script>
